import "./App.css";
import Dictionary from "./components/Dictionary/Dictionary.component";

function App() {
  return <Dictionary />;
}

export default App;
